import Vue                      from "vue";
import { mapGetters }           from "vuex";
import { ShippingDetailService, 
    ErrorLogService }           from "@/services";
import { LoadingSpinner }       from "@/components/Elements"

export default Vue.extend({
    name: "ShippingDetail",
    components: {
        LoadingSpinner
    },
    props: {
        invoiceId: Number,
        invoiceSource: String,
        invoiceNumber: String,
        carrierTrackingNumber: String,
        trackingUrl: String
    },
    data: () => ({
        shippingDetail: [],
        isBusy: false,
        isLanter: false,
        errorMessage: "",
    }),
    computed: {
        ...mapGetters(["user", "activeAccountId", "McfCostCenterId", "activeAccountId"]),
    },
    mounted() {
        this.getShippingDetail();
    },
    methods: {
        async getShippingDetail() {
            try {
                this.isBusy = true;
                
                let params = {
                    accountId: this.activeAccountId,
                    userId: this.user.UserId,
                    invoiceId: this.invoiceId,
                    source: this.invoiceSource
                }
                
                this.shippingDetail = await ShippingDetailService.getLanterScanDetails(params);                
            } catch (err) {
                this.errorMessage = ErrorLogService.LogAndGetErrorMessage(err);
            } finally {
                this.isBusy = false;
                this.isLanter = this.shippingDetail.length > 0;
            }
        },
        goToDetail() {
            this.$emit("loadDetail", this.shippingDetail, this.invoiceNumber, this.invoiceId);
        }
    },
    watch: {
        // this component creates once and exists while paging while the values update, so lifecycle
        // hooks don't trigger, need this watcher so we update the shipping detail when a user pages
        // through invoice results
        invoiceId(newValue,oldValue) 
        {
            this.getShippingDetail();
        }
    }
})